// extracted by mini-css-extract-plugin
export var acitonButtons = "_ic-0";
export var additionalIcon = "_ic-f";
export var block = "_ic-1";
export var blockContent = "_ic-7";
export var blockDescription = "_ic-8";
export var blockIcon = "_ic-9";
export var blockTitle = "_ic-6";
export var border = "_ic-a";
export var center = "_ic-l";
export var edge = "_ic-b";
export var edgeLabel = "_ic-c";
export var edgePath = "_ic-d";
export var error = "_ic-e";
export var flowchart = "_ic-g";
export var flowchartContent = "_ic-h";
export var highlighted = "_ic-3";
export var hover = "_ic-4";
export var icon = "_ic-i";
export var left = "_ic-m";
export var navButton = "_ic-j";
export var navButtons = "_ic-k";
export var right = "_ic-n";
export var selected = "_ic-2";
export var small = "_ic-5";